import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Paper, Button } from '@material-ui/core';
import {
  PhoneAndroid,
  MailOutline,
  CheckCircle,
  Error,
  EditOutlined,
} from '@material-ui/icons';

import { Typography } from '../../../../../components/Wrappers/Wrappers.jsx';
import ButtonProgress from '../../../../../commons/ButtonProgress';
import { useStyles } from '../styles.js';
import classNames from 'classnames';

const ICON_MAP = {
  'phone': <PhoneAndroid fontSize='small' />,
  'email': <MailOutline fontSize='small' />,
}

function VerificationCard ({
  cardId, cardLabel, cardValue, isEditable, isVerified, isLoading, onVerifyButtonClick, onChangeButtonClick }) {
  const classes = useStyles();

  function renderChangeButton () {
    if (isEditable === 'true') {
      return (
        <React.Fragment>
          <Button
            startIcon={<EditOutlined className={classes.editIcon} />}
            className={classes.changeBtn}
            onClick={onChangeButtonClick}
          >
            Change
          </Button>
        </React.Fragment>
      )
    }

    return <></>
  }

  function renderVerifyButton () {
    if (isVerified === 'true') {
      return (
         <React.Fragment>
              <div className={classes.statusText} style={{ color: '#5A5959' }}>
                <CheckCircle
                  className={classes.statusIcon}
                  style={{ color: '#00D456' }}
                />
                Verified
              </div>
         </React.Fragment>
      )
    } 

    return (
      <React.Fragment>
        <div className={classes.statusText} style={{ color: '#5A5959' }}>
          <Error
            className={classes.statusIcon}
            style={{ color: '#FD1818' }}
          />
          Unverified
        </div>
        <ButtonProgress
          label="VERIFY"
          variant="outlined"
          onClick={onVerifyButtonClick}
          showProgress={isLoading}
          width="90px"
        />
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
        <Paper className={classNames([classes.card, classes.cardPhoneNumber])}>
          <div className={classes.leftSection}>
            <div className={classes.iconBox}>
              {ICON_MAP[cardId]}
            </div>
            <div>
              <Typography
                variant='subtitle1'
                weight={'bold'}
                className={classes.subTitle}
              >
                {cardLabel}
              </Typography>
              <div className={classes.contentBody}>
                <Typography variant='body2' className={classes.subValue}>
                  {cardValue}
                </Typography>
                {renderChangeButton()}
              </div>
            </div>
          </div>
          <div className={classes.rightSection}>
          {renderVerifyButton()}
        </div>
        </Paper>
    </React.Fragment>
  );
}

VerificationCard.propTypes = {
  cardId: PropTypes.string,
  cardLabel: PropTypes.string,
  cardValue: PropTypes.string,
  isEditable: PropTypes.string,
  isVerified: PropTypes.string,
  isLoading: PropTypes.bool,
};

VerificationCard.defaultProps = {
  cardId: '',
  cardLabel: '',
  cardValue: '',
  isEditable: 'false',
  isVerified: 'false',
  isLoading: false,
};

export default observer(VerificationCard);
